export function checkFeatureFlagChanged(a, b) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  const commonKeys = aKeys.filter(key => bKeys.includes(key));
  const changedValues = [];

  // check if feature flag value changed
  commonKeys.forEach(key => {
    if (a[key].enabled !== b[key].enabled) {
      changedValues.push(b[key]);
    }
  });

  // check if new feature flag added
  if (aKeys.length !== bKeys.length) {
    bKeys.forEach(key => {
      // check if new feature flag added and it's enabled
      if (!aKeys.includes(key) && b[key].enabled) {
        changedValues.push(b[key]);
      }
    });
  }

  // return false if no changes
  if (!changedValues.length) {
    return {
      changed: false,
      reload: false,
    };
  }

  // check if any of the changed feature flag has reload_page set to true
  const hasReloadPage = changedValues.some(obj => obj && obj.reload_page === true);

  return {
    changed: true,
    reload: hasReloadPage,
  };
}

